import React from 'react';
import PropTypes from 'prop-types';

const CheckboxInputField = ({
  id,
  label = '',
  description = '',
  isRequired = false,
  className = '',
  errorMsg = [],
  touched = false,
  onChange = () => {},
  onBlur = () => {},
  checked = false,
}) => {
  const handleChange = (e) => {
    // modify event to make value match "checked"
    onChange({
      target: {
        name: e.target.name,
        value: e.target.checked,
        type: e.target.type,
        checked: e.target.checked,
      },
    });
  };
  const fullClassName = `${className} ${(touched && errorMsg.length) ? 'has-error' : ''} quick-tip-anchor`;
  return (
    <div className={fullClassName} style={{ marginBottom: '16px' }}>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '1.5rem', verticalAlign: 'text-top' }}>
          <input type="checkbox" id={id} name={id} checked={!!checked} onChange={handleChange} onBlur={onBlur} />
        </div>
        <div style={{ flex: '1', verticalAlign: 'text-top' }}>
          <div>
            <label htmlFor={id} style={{ display: 'inline', cursor: 'pointer' }}>
              {label && (
                <span className="press-release-content__label">{label}</span>
              )}
              {isRequired && (
                <span className="form__required-tag">*</span>
              )}
            </label>
          </div>
          <div style={{ color: '#6e707c' }}>
            {description}
          </div>
          {touched && errorMsg.length > 0 && (
            <p className="form-error__message">
              {Array.isArray(errorMsg) ? (
                errorMsg.map((error, index, allErrors) => {
                  if (!error) { // skip empty errors
                    return '';
                  }
                  if (index === allErrors.length - 1) { // last item
                    return error;
                  }
                  return (<>{error}<br /></>); // append newline
                })
              ) : (
                errorMsg
              )}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

CheckboxInputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  errorMsg: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  touched: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  checked: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
};

export default CheckboxInputField;
